export const getMeetingHistory = (state) => state.meetingHistory.data;
export const isMeetingHistoryLoading = (state) => state.meetingHistory.isLoading;
